<template>
    <div class="row">
        
        <div class="col s12">
                
            <fieldset><legend>Bolsistas</legend>
                <base-table v-if="bolsistas && bolsistas.length">
                    <tr slot='head'>
                        <th>Bolsista</th>
						<th>Ação</th>
                        <th>Nota</th>
                        <th>Ações</th>
                    </tr>
                    <tr slot='body' v-for="(bolsista,index) in bolsistas" :key="index">
                        <td>{{bolsista.name}}</td>
						<td>{{bolsista.titulo}}</td>
                        <td v-if="bolsista.notaTotal && totalAvaliado(bolsista)">{{bolsista.notaTotal}}</td>
						<td v-if="bolsista.notaTotal && !totalAvaliado(bolsista)">Nota parcial: {{bolsista.notaTotal}}</td>
                        <td v-if="!bolsista.notaTotal">Não Avaliado</td>
                        <td>
                            <button 
                                class="waves-effect waves-light btn modal-trigger" 
                                :data-target="`modal${index}`"
                                @click.prevent="setSelectedBolsista(index)"
                            >Avaliar</button>
                            <avaliacao-relatorio-modal
                                :bolsista ="bolsista"
                                @get-nota-total="setNotaTotal"
                                :index="index"
                                />
                        </td>
                    </tr>
                    
                </base-table>
            </fieldset>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';

const BOLSISTAS_URL = '/api/relatorios/projetos/usuarios/{id}/bolsistas/{avaliacaoId}';
const AVALIACAO_RELATORIO_URL = '/api/avaliacaoRelatorio';
import AvaliacaoNota from './AvaliacaoNota.vue';
import AvaliacaoRelatorioModal from './AvaliacaoRelatorioModal.vue';

import BaseTable from './BaseTable.vue';
export default {
    name: 'AvaliacaoRelatorioListBolsistas',
    components:{
        AvaliacaoNota,
        BaseTable,
        AvaliacaoRelatorioModal,
        
    },
    data(){
        return {
            selectedIndex:0,
            selectedBolsista: undefined,
            bolsistas: [],
            qtdBolsistas: 0,
            notaBolsistas: 0
        }
    },
    computed:{
        ...mapState(["project"])
    },
    watch:{
        bolsistas(newValue, oldValue){
            if(newValue.length){
                this.$set(this,'notaBolsistas',this._sum(newValue));
                this.$set(this,'qtdBolsistas',newValue.length);
                this._emitNotaParcial();
            }

        }
    },
    methods:{
        ...mapActions(["setAvaliacaoRelatorioBolsistas"]),
        _sum(array){
            if(!array)
                return 0;
            return array
                    .map(e => e.notaTotal)
                    .reduce( (acc, currentValue) => Number(acc) + Number(currentValue));
        },
        _emitNotaParcial(){
            this.$emit('set-nota-parcial',{"nota":this.notaBolsistas,"qtd":this.qtdBolsistas});
        },
        async _avaliar(){
            try {
                let { data } = await this.$http.post(AVALIACAO_RELATORIO_URL,{
                    "id": this.project.avaliacao.id,
                    "avaliacaoRelatorio": this.project.avaliacao.avaliacao_relatorio
                });
                this.$set(this,'qtdBolsistas',this.bolsistas.length);
                this.$set(this,'notaBolsistas',this._sum(this.bolsistas));
                this._emitNotaParcial();
                

            } catch (error) {
                let {body, status} = error;
                showMsg(body,status);
                console.log(error);
            }
        },
        async _setBolsistas(){
            try {
                let {data} = await this.$http.get(BOLSISTAS_URL,{
                    params:{
                        id:this.project.curriculo.user_id,
                        avaliacaoId:this.project.avaliacao.id
                    }
                    
                });
                if(data['error'])
                    this.setEditalStatus(data);
                else{
                    let { bolsistas } = data;
                    if(this.project.avaliacao.avaliacao_relatorio == null){
                        this.project.avaliacao.avaliacao_relatorio = {};
                        this.project.avaliacao.avaliacao_relatorio.bolsistas = [];
                    }
                    this.setAvaliacaoRelatorioBolsistas(bolsistas);
                    this.$set(this,'bolsistas', bolsistas);
                }

            } catch ({status,data}) {
                if(status == 403){
                   this.setEditalStatus({"error":true,"message":"Acesso não autorizado"});;
                }
            }
        },
        setEditalStatus(payload){
            this.$emit('get-edital-status',payload);
        },
        getBolsista(index){
            return this.bolsistas[index];
        },
        setNotaTotal(payload){
            let {items,notaTotal} = payload;
            let bolsista = this.getBolsista(this.selectedIndex);
            bolsista.items = items;
            bolsista.notaTotal = notaTotal;
            this._setBolsista(bolsista,this.selectedIndex);

        },
        _setBolsista(bolsista,index){
            this.$set(this.bolsistas,index,bolsista);
            this.setAvaliacaoRelatorioBolsistas(this.bolsistas);
            this._avaliar();
        },
        setSelectedBolsista(index){
            this.$set(this,'selectedIndex', index);
            let bolsista = this.getBolsista(index);
            this.$set(this,'selectedBolsista',bolsista);
        },
        
        async init(){
            try {
                let {bolsistas} = this.project.avaliacao.avaliacao_relatorio;
                if(!bolsistas)    
                    throw null;
                this.$set(this,"bolsistas",bolsistas);
                
            } catch (error) {
               await  this._setBolsistas();
            }     
        },
		totalAvaliado(bolsista) {
			var items = bolsista.items,
				i = bolsista.items.length;
			
			while (--i >= 0)
				if (bolsista.items[i].nota === null)
					return false;
			return true;
		}
    },
    mounted(){
        this.init();
    }
    
    
}
</script>
 

